import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { COLORS } from '../../styles/tokens';

const ROLE_LABEL = { driver: 'sjåfør', orderer: 'bestiller' };

export default function AdminViewingAsBanner() {
  const { viewingAs, setViewingAs } = useAuth();

  if (!viewingAs || viewingAs === 'admin') return null;

  return (
    <div style={styles.banner}>
      <span style={styles.text}>
        Du ser appen som <strong>{ROLE_LABEL[viewingAs] ?? viewingAs}</strong>
      </span>
      <button style={styles.btn} onClick={() => setViewingAs(null)}>
        Tilbake til admin
      </button>
    </div>
  );
}

const styles = {
  banner: {
    background: COLORS.brandPanel,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: '6px 16px',
    fontSize: 13,
    flexShrink: 0,
  },
  text: { letterSpacing: 0.2 },
  btn: {
    background: 'rgba(255,255,255,0.15)',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 6,
    padding: '3px 12px',
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
  },
};
